import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import DayPickerInput from './day-picker-input';

function FormikDayPickerInput(props) {
  const { fieldConfig, FieldHelperTextProps, onChange, ...others } = props;
  const [{ onBlur, ...field }, meta, helpers] = useField(fieldConfig);

  return (
    <>
      <DayPickerInput
        {...field}
        onChange={(...args) => {
          helpers.setValue(args[1]);
          helpers.setTouched(true);
          if (onChange) {
            onChange(...args);
          }
        }}
        {...others}
        InputProps={{ error: meta.touched && !!meta.error, ...others.InputProps }}
      />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </>
  );
}
FormikDayPickerInput.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  onChange: PropTypes.func,
  // all other props will be applied to InputBase component
};

export default FormikDayPickerInput;
